export enum markdownPaths {
    // API Web Reference
    APIWebReferenceOverviewURL =
    "https://public2sustamize.blob.core.windows.net/assets/ilcd-docs/knowledge-hub/APIWebReferenceOverview.md",
  APIWebReferenceAPICallsURL =
    "https://public2sustamize.blob.core.windows.net/assets/ilcd-docs/knowledge-hub/APIWebReferenceAPICalls.md",
  APIWebReferenceAccessTokenURL =
    "https://public2sustamize.blob.core.windows.net/assets/ilcd-docs/knowledge-hub/APIWebReferenceAccessToken.md",

// DB Overview
 KHEnergyURL =
"https://public2sustamize.blob.core.windows.net/assets/ilcd-docs/knowledge-hub/KHEnergy_20260529.md",
 KHMaterialsURL =
"https://public2sustamize.blob.core.windows.net/assets/ilcd-docs/knowledge-hub/KHMaterials.md",
 KHProductionURL =
"https://public2sustamize.blob.core.windows.net/assets/ilcd-docs/knowledge-hub/KHProduction.md",
 KHElectronicsURL =
"https://public2sustamize.blob.core.windows.net/assets/ilcd-docs/knowledge-hub/KHElectronics.md",
 KHLogisticsURL =
"https://public2sustamize.blob.core.windows.net/assets/ilcd-docs/knowledge-hub/KHLogistics.md",
 KHDBOverviewURL =
"https://public2sustamize.blob.core.windows.net/assets/ilcd-docs/knowledge-hub/KHDBOverview.md",

// Toolbox Overview
 KHToolboxMatcherURL =
"https://public2sustamize.blob.core.windows.net/assets/ilcd-docs/knowledge-hub/KHToolboxMatcher.md",
 KHToolboxAssemblerURL =
"https://public2sustamize.blob.core.windows.net/assets/ilcd-docs/knowledge-hub/KHToolboxAssembler.md",
 KHToolboxInterpreterURL =
"https://public2sustamize.blob.core.windows.net/assets/ilcd-docs/knowledge-hub/KHToolboxInterpreter.md",
 KHToolboxMpnSearchURL =
"https://public2sustamize.blob.core.windows.net/assets/ilcd-docs/knowledge-hub/KHToolboxMpnSearch.md",
 KHToolboxOverviewURL =
"https://public2sustamize.blob.core.windows.net/assets/ilcd-docs/knowledge-hub/KHToolboxOverview.md",



// Getting Started
 GettingStartedCommercialsURL =
"https://public2sustamize.blob.core.windows.net/assets/ilcd-docs/knowledge-hub/KHGettingStartedCommercials.md",
 GettingStartedDevelopersURL =
"https://public2sustamize.blob.core.windows.net/assets/ilcd-docs/knowledge-hub/KHGettingStartedDevelopersAndPartners.md",

// Releases

 KHReleasesURL =
"https://public2sustamize.blob.core.windows.net/assets/ilcd-docs/knowledge-hub/KHReleasesV3.3.1.md",
KHReleaseProcessURL =
"https://public2sustamize.blob.core.windows.net/assets/ilcd-docs/knowledge-hub/KHReleaseProcess.md",


// Data Quality
KHDataQualityURL =
"https://public2sustamize.blob.core.windows.net/assets/ilcd-docs/knowledge-hub/KHDataQualityV3.3.0.md",

// FAQ
 FAQDatabseURL =
"https://public2sustamize.blob.core.windows.net/assets/ilcd-docs/knowledge-hub/faq/FAQDatabase.md",
 FAQLicensesURL =
"https://public2sustamize.blob.core.windows.net/assets/ilcd-docs/knowledge-hub/faq/FAQLicenses.md",
  }